{
    "Branding_Labels_BrandingEnabled": "Branding inschakelen voor deze CME?",
    "Branding_Tab_Name_Colours": "Kleuren",
    "Branding_Tab_Name_AdditionalColours": "Andere kleuren",
    "Branding_Tab_Name_Imagery": "Beeldspraak",
    "Branding_Tab_Name_Languages": "Taal",
    "Branding_Tab_Name_SSOButtons": "SSO-knoppen",
    "Branding_Tab_Name_Links": "Links",
    "Branding_Labels_DarkMode": "(Donkere modus)",
    "Branding_Subtitles_ColourPalette": "Kleurenpalet",
    "Branding_Labels_PrimaryColour": "Primair",
    "Branding_Labels_SecondaryColour": "Secundair",
    "Branding_Labels_TertiaryColour": "Tertiair",
    "Branding_Subtitles_HeaderSidebarColours": "Koptekst-\/zijbalkkleuren",
    "Branding_Labels_HeaderSidebarBackgroundColour": "Koptekst\/zijbalkachtergrond",
    "Branding_Labels_HeaderSidebarBackgroundContrastColour": "Koptekst\/zijbalkaccent",
    "Branding_Labels_HeaderSidebarIconColour": "Koptekst-\/zijbalkpictogrammen",
    "Branding_Subtitles_RouterColours": "Routerkleuren",
    "Branding_Labels_RouterLoaderBackgroundColour": "Router Loader Achtergrond",
    "Branding_Labels_RouterLoaderForegroundColour": "Router Loader Voorgrond",
    "Branding_Subtitles_DashboardColours": "Dashboardkleuren",
    "Branding_Labels_Dashboard_1_BgColour": "Dashboard 1 Achtergrond",
    "Branding_Labels_Dashboard_1_FgColour": "Dashboard 1 Voorgrond",
    "Branding_Labels_Dashboard_2_BgColour": "Dashboard 2 Achtergrond",
    "Branding_Labels_Dashboard_2_FgColour": "Dashboard 2 Voorgrond",
    "Branding_Labels_Dashboard_3_BgColour": "Dashboard 3 Achtergrond",
    "Branding_Labels_Dashboard_3_FgColour": "Dashboard 3 Voorgrond",
    "Branding_Labels_Dashboard_4_BgColour": "Dashboard 4 Achtergrond",
    "Branding_Labels_Dashboard_4_FgColour": "Dashboard 4 Voorgrond",
    "Branding_Labels_Dashboard_5_BgColour": "Dashboard 5 Achtergrond",
    "Branding_Labels_Dashboard_5_FgColour": "Dashboard 5 Voorgrond",
    "Branding_Labels_Dashboard_6_BgColour": "Dashboard 6 Achtergrond",
    "Branding_Labels_Dashboard_6_FgColour": "Dashboard 6 Voorgrond",
    "Branding_Subtitles_AuthColours": "Autorisatiekleuren",
    "Branding_Labels_Auth_Subtitle_HighlightColour": "Autorisatie Markeerkleur",
    "Branding_Subtitles_InsightsColours": "Inzichten Kleuren",
    "Branding_Labels_Insights_Stat_1_Colour": "Inzichten Stat 1",
    "Branding_Labels_Insights_Stat_2_Colour": "Inzichten Stat 2",
    "Branding_Labels_Insights_Stat_3_Colour": "Inzichten Stat 3",
    "Branding_Labels_Insights_Stat_4_Colour": "Inzichten Stat 4",
    "Branding_Labels_Insights_Stat_5_Colour": "Inzichten Stat 5",
    "Branding_Labels_Insights_Percentage_Increase": "Veranderindicator - Verbetering",
    "Branding_Labels_Insights_Percentage_Decrease": "Veranderindicator - Afname",
    "Branding_Labels_Insights_Percentage_NoChange": "Geen verandering indicator",
    "Branding_Labels_Insights_Quick_BusiestDay": "Inzichten Drukste dag",
    "Branding_Labels_Insights_Quick_BusiestTime": "Inzichten Drukste Tijd",
    "Branding_Labels_Highlights_MostCalled": "Hoogtepunten Meest gebeld",
    "Branding_Labels_Highlights_MostAnsweredCalls": "Hoogtepunten Meest beantwoorde oproepen",
    "Branding_Subtitles_CompanyLogos": "Bedrijfslogo's",
    "Branding_Labels_Imagery_MainLogo": "Hoofdlogo (voor op een donkere achtergrond)",
    "Branding_Labels_Imagery_MainLogo_White": "Hoofdlogo (voor op een witte achtergrond)",
    "Branding_Labels_Imagery_Favicon": "Favicon (.ico-bestand)",
    "Branding_Labels_Imagery_SquareLogo": "Vierkant logo",
    "Branding_Labels_Imagery_BroadworksLogo": "Broadworks-logo",
    "Branding_Subtitles_Authorisation": "Autorisatie-afbeeldingen",
    "Branding_Labels_Imagery_AuthBg": "Autorisatieachtergrond (afbeelding of video)",
    "Branding_Subtitle_AuthLanguages": "Inlogpagina",
    "Branding_Labels_AuthTitle": "Ondertitel inlogpagina",
    "Branding_Labels_AuthTitle2": "Inlogpagina Ondertitel Regel 2",
    "Branding_Subtitle_Broadworks": "Broadworks",
    "Branding_Labels_BroadworksName": "Broadworks-naam",
    "Branding_Subtitle_SSOButtons": "SSO-knoppen",
    "Branding_Labels_SSOIcon": "Icon",
    "Branding_Labels_SSOLabel": "Label",
    "Branding_Labels_SSOUrl": "URL",
    "Branding_Labels_MainSiteLink": "Hoofdsitelink",
    "Branding_Validation_MustBeValidURL": "Moet een geldige URL zijn",
    "Branding_SSO_Buttons_Add": "SSO-knop toevoegen",
    "Branding_SSO_Buttons_Remove": "Verwijder SSO-knop",
    "Branding_Labels_VanityURL": "URL",
    "Branding_ResetButton": "Terugzetten naar vorige versie",
    "Branding_RestoreCurrentVersion": "Terug naar huidige versie",
    "Branding_ApplyPreviewButton": "Klik om een voorbeeld te bekijken",
    "Branding_PreviewButton": "Er is een conceptversie beschikbaar. Klik om een voorbeeld te bekijken.",
    "Branding_DeletePreview": "Voorbeeld verwijderen",
    "Branding_UndoChanges": "Huidige wijzigingen wissen",
    "Branding_Required_Message": "Dit veld is verplicht",
    "Branding_Submission_Line1": "Wij creëren uw branding voor u",
    "Branding_Submission_Line2": "Dit kan een paar seconden duren",
    "Branding_Validation_MaxWordLength": "Geen enkel woord mag langer zijn dan {} tekens",
    "Branding_Validation_MaxLength": "Mag niet langer zijn dan {} tekens",
    "NAME": "BrandingLanguage"
}